import { Container, SubTitle, MoneyTextMask } from './styles'

export default function Customer ({ data: customer }) {
  return (
    <Container>
      <SubTitle>
        {customer.name}
      </SubTitle>
      <MoneyTextMask value={customer.totalSpent} style={{justifySelf: 'center'}}/>
    </Container>
  )
}
